import React, { forwardRef, useImperativeHandle } from "react";

import * as Api from "@modules/api";
import { ContentComponentRefType } from "@modules/content/types";
import ContentComponentSelector, {
  ExtraProps,
} from "@modules/content/components";

export type DynamicZoneProps = {
  items: Api.Server.ComponentWithUniqueIdOutput[];
  context?: Api.Server.ContentEntityOutput | undefined;
  onRefresh?: () => void | Promise<void>;
  isRefreshing?: boolean;
  header?: React.ReactElement;
  onItemPress?: (
    content: Api.Server.ContentEntityOutput,
    itemParams: { [key: string]: string | string[] | null | undefined }
  ) => void | Promise<void>;
  criteria?: string;
  withContext?: boolean;
  extraProps?: ExtraProps;
};

export type DynamicZoneRefType = {
  refresh?: () => void | Promise<void>;
};

// export interface PageWithDynamicZoneLayoutProps {
//   pageData: Server.CollectionComponentDetailsOutput | undefined | null;
//   context?: Server.ContentEntityOutput;
//   areDynamicZonesHidden?: boolean;
//   pageDataContextId?: string | undefined;
//   hasOverflow?: boolean;
//   detailsSeeMoreType?: 'categories' | 'curatedlist';
// }

export const PageWithDynamicZoneLayout = forwardRef<
  DynamicZoneRefType,
  React.PropsWithChildren<DynamicZoneProps>
>(
  (
    {
      children,
      withContext = false,
      ...props
    }: React.PropsWithChildren<DynamicZoneProps>,
    ref: React.Ref<DynamicZoneRefType>
  ) => {
    const refs = React.useRef<ContentComponentRefType[]>([]);

    useImperativeHandle(ref, () => ({
      refresh: () => {
        refs.current.forEach((ref) => ref?.refresh?.());
      },
    }));

    const areDynamicZonesHidden = false;

    return (
      <div
        className={`cus-scrollbar-w-none relative mb-auto h-full w-full overflow-y-auto pb-10`}
      >
        {children}
        {props?.items?.length &&
        ((withContext && props?.context) ||
          (!withContext && !props?.context)) ? (
          <div
            className={`flex w-full flex-col space-y-4 bg-white sm:space-y-0 dark:bg-[#010D19] ${
              children && "pt-4"
            } ${areDynamicZonesHidden && "hidden"}`}
          >
            {props.items.map((dynamicZone, i) => (
              <ContentComponentSelector
                key={dynamicZone?.id + "" + props.context?.id}
                className={` ${
                  i < props.items.length - 1 ? "border-b-[0.5px]" : ""
                }`}
                context={props.context}
                identifier={dynamicZone?.type + ""}
                component={dynamicZone}
                criteria={props.criteria}
                componentRef={(ref) => {
                  if (ref) {
                    refs.current[i] = ref;
                  }
                }}
                extraProps={props.extraProps}
                // isLastSibling={
                //   pageData?.dynamicZone?.length &&
                //   pageData?.dynamicZone?.length - 1 === i
                // }
                // pageSize={10}
                // pageDataId={pageData.id}
                // pageDataContextId={pageDataContextId}
                // seeMoreType={detailsSeeMoreType}
              />
            ))}
          </div>
        ) : null}
      </div>
    );
  }
);

export default PageWithDynamicZoneLayout;
